import state from "./posState";
import mutations from "./posMutations";
import getters from "./posGetters";
import actions from "./posActions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
